import type { CameraView, Point } from "./types";

export interface ViewportTransform {
  scale: number;
  offset: Point;
}

export const computeTransform = (
  viewport: { width: number; height: number },
  artboard: { width: number; height: number },
  camera: CameraView,
  fit: "contain" | "cover" = "contain",
): ViewportTransform => {
  const fitScale = fit === "cover"
    ? Math.max(viewport.width / artboard.width, viewport.height / artboard.height)
    : Math.min(viewport.width / artboard.width, viewport.height / artboard.height);
  const scale = fitScale * camera.zoom;
  return {
    scale,
    offset: {
      x: viewport.width / 2 - camera.center.x * scale,
      y: viewport.height / 2 - camera.center.y * scale,
    },
  };
};

export const artboardToViewport = (
  point: Point,
  transform: ViewportTransform,
  groupOffset: Point = { x: 0, y: 0 },
): Point => ({
  x: transform.offset.x + (point.x + groupOffset.x) * transform.scale,
  y: transform.offset.y + (point.y + groupOffset.y) * transform.scale,
});

export const viewportToArtboard = (
  point: Point,
  transform: ViewportTransform,
  groupOffset: Point = { x: 0, y: 0 },
): Point => ({
  x: (point.x - transform.offset.x) / transform.scale - groupOffset.x,
  y: (point.y - transform.offset.y) / transform.scale - groupOffset.y,
});
